/** @format */

import {createContext, ReactNode, useContext, useState} from 'react';

const SearchQueryContext = createContext<string | null>(null);
const SetSearchQueryContext = createContext<((value: string) => void) | null>(null);

export const ChiefReportProvider = ({children}: {children: ReactNode}) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <SetSearchQueryContext.Provider value={setSearchQuery}>
      <SearchQueryContext.Provider value={searchQuery}>{children}</SearchQueryContext.Provider>
    </SetSearchQueryContext.Provider>
  );
};

// Subscribes to searchQuery — re-renders on every change.
export const useSearchQuery = (): string => {
  const value = useContext(SearchQueryContext);
  if (value === null) {
    throw new Error('useSearchQuery must be used within ChiefReportProvider');
  }
  return value;
};

// Does NOT subscribe to searchQuery — setter is stable, consumer does not re-render on changes.
export const useSetSearchQuery = (): ((value: string) => void) => {
  const setter = useContext(SetSearchQueryContext);
  if (setter === null) {
    throw new Error('useSetSearchQuery must be used within ChiefReportProvider');
  }
  return setter;
};
